import { Pipe, PipeTransform } from '@angular/core';
import { RoundingStrategy } from '@shared/enums/rounding-strategy.enum';
import { Decimal } from 'decimal.js';

@Pipe({
  name: 'roundNumber',
  standalone: true,
})
export class RoundNumberPipe implements PipeTransform {
  private static readonly ROUNDING_MAP: Record<
    Exclude<RoundingStrategy, RoundingStrategy.Truncate>,
    Decimal.Rounding
  > = {
    [RoundingStrategy.HalfUp]: Decimal.ROUND_HALF_UP,
    [RoundingStrategy.HalfDown]: Decimal.ROUND_HALF_DOWN,
    [RoundingStrategy.HalfEven]: Decimal.ROUND_HALF_EVEN,
    [RoundingStrategy.Up]: Decimal.ROUND_UP,
    [RoundingStrategy.Ceiling]: Decimal.ROUND_CEIL,
    [RoundingStrategy.Down]: Decimal.ROUND_DOWN,
    [RoundingStrategy.Floor]: Decimal.ROUND_FLOOR,
  };

  transform(
    value: number | null | undefined,
    decimals: number,
    strategy?: RoundingStrategy
  ): string | null {
    if (value === null) {
      return '';
    }

    if (decimals === null || strategy === null || strategy === undefined) {
      return value.toString();
    }

    const decimal = new Decimal(value);

    if (strategy === RoundingStrategy.Truncate) {
      return decimal.trunc().toString();
    }

    const roundingMode = RoundNumberPipe.ROUNDING_MAP[strategy];

    if (roundingMode == null) {
      return value.toString();
    }

    return decimal.toDecimalPlaces(decimals, roundingMode).toString();
  }
}
